<template>
  <div class="main">
    <PageLoader :isActive="isLoading"/>
    <Nav :authRequired = "true"/>
    <div class="container">
      <div class="row mb-x2">
        <div class="col">
          <button @click="goBack" class="zero-btn zero-btn-standard zero-btn-primary zero-btn-outline slim mb-x2">
            <i class="fas fa-chevron-left mr-x1"></i> BACK
          </button>
          <h2 v-if="!editMode">Create a Job</h2>
          <h2 v-else>Edit Job</h2>
        </div>
      </div>
      <div class="row mb-x4">
        <div class="col-md mb-x2 order-md-1 d-flex flex-column align-items-start">
          <template v-if="editMode">
            <router-link :to="'/jobs/' + eventId + '/days'" class="zero-btn zero-btn-standard zero-btn-primary zero-btn-outline mb-x1">
              <i class="fas fa-calendar mr-x1"></i>Manage days for this job
            </router-link>
            <router-link :to="'/jobs/' + eventId + '/shots'" class="zero-btn zero-btn-standard zero-btn-primary zero-btn-outline mb-x1">
              <i class="fas fa-camera mr-x1"></i>Manage shots for this job
            </router-link>
            <button class="zero-btn zero-btn-standard zero-btn-destructive zero-btn-outline mb-x1" @click="verifyDelete = true">
              <i class="fas fa-trash mr-x1"></i>Delete this job
            </button>
          </template>
        </div>
        <div class="col-md zero-form mb-x8 order-md-0">
          <div class="input-block mb-x2">
            <label for="event-name">
              event name
            </label>
            <input
              type="text"
              id="event-name"
              name="event-name"
              placeholder=""
              class="standard-text-input"
              v-model="eventData.event_name"
              :class="{ 'has-error': errors.name }"
              autocomplete="off"
            >
            <p class="input-error" v-if="errors.name">
              Please enter a name for the event
            </p>
          </div>
          <div class="input-block mb-x2">
            <label for="location">
              location
            </label>
            <textarea
              id="location"
              name="location"
              placeholder=""
              class="standard-text-area"
              v-model="eventData.location"
              :class="{ 'has-error': errors.location }"
              autocomplete="off"
            ></textarea>
            <p class="input-error" v-if="errors.location">
              Please enter a location
            </p>
          </div>
          <div class="input-block mb-x2">
            <label for="creatives">
              creatives
            </label>
            <CreativesList v-if="users.length !== 0" :allUsers="users" :creatives="eventData.creatives" picker @selectedCreatives="setCreatives" />
          </div>
          <div class="input-block mb-x2">
            <label for="calltime">
              calltime
            </label>
            <input
              type="text"
              id="calltime"
              name="calltime"
              placeholder=""
              class="standard-text-input"
              v-model="eventData.calltime"
              autocomplete="off"
            >
          </div>
          <div class="input-block mb-x2">
            <label for="travel">
              parking &amp; arrival
            </label>
            <textarea
              id="travel"
              name="travel"
              placeholder=""
              class="standard-text-area"
              v-model="eventData.travel"
              autocomplete="off"
            ></textarea>
          </div>
          <div class="input-block mb-x2">
            <label for="traveldates">
              travel dates
            </label>
            <textarea
              id="traveldates"
              name="traveldates"
              placeholder=""
              class="standard-text-area"
              v-model="eventData.traveldates"
              autocomplete="off"
            ></textarea>
          </div>
          <!-- flight/hotel upload -->
          <div class="mb-x1">
            <div class="micro-label">flight/hotel</div>
            <div class="value" v-if="eventData.flighthotel">
              <img class="uploaded-image" :src="filePath + 'uploads/files/' + eventData.flighthotel" >
            </div>
            <div v-else class="value">
              no image uploaded
            </div>
          </div>
          <div class="input-block mb-x2">
            <label for="flighthotel-input">
              <div class="label-inner">upload new flight/hotel image</div>
            </label>
            <input
              type="file"
              id="flighthotel-input"
              name="flighthotel-input"
              placeholder=""
              class="standard-text-input mb-x2"
              autocomplete="off"
              ref="flighthotelinput"
              @change="fileInputChange('flighthotelinput')"
              accept=".pdf,.jpg,.jpeg,.png,.csv"
            >
          </div>
          <!-- team assignment upload -->
          <div class="mb-x1">
            <div class="micro-label">team assignment</div>
            <div class="value" v-if="eventData.assignments">
              <img class="uploaded-image" :src="filePath + 'uploads/files/' + eventData.assignments" >
            </div>
            <div v-else class="value">
              no image uploaded
            </div>
          </div>
          <div class="input-block mb-x2">
            <label for="assignment-input">
              <div class="label-inner">upload new team assignment image</div>
            </label>
            <input
              type="file"
              id="assignment-input"
              name="assignment-input"
              placeholder=""
              class="standard-text-input mb-x2"
              autocomplete="off"
              ref="assignmentinput"
              @change="fileInputChange('assignmentinput')"
              accept=".pdf,.jpg,.jpeg,.png,.csv"
            >
          </div>
          <div class="input-block mb-x2">
            <label for="headshotcafe">
              headshot cafe
            </label>
            <textarea
              id="headshotcafe"
              name="headshotcafe"
              placeholder=""
              class="standard-text-area"
              v-model="eventData.headshotcafe"
              autocomplete="off"
            ></textarea>
          </div>
          <div class="input-block mb-x2">
            <label for="video">
              video
            </label>
            <textarea
              id="video"
              name="video"
              placeholder=""
              class="standard-text-area"
              v-model="eventData.video"
              autocomplete="off"
            ></textarea>
          </div>
          <div class="input-block mb-x2">
            <label for="services">
              services
            </label>
            <textarea
              id="services"
              name="services"
              placeholder=""
              class="standard-text-area"
              v-model="eventData.services"
              autocomplete="off"
            ></textarea>
          </div>
          <div class="input-block mb-x2">
            <label for="onsite">
              onsite
            </label>
            <textarea
              id="onsite"
              name="onsite"
              placeholder=""
              class="standard-text-area"
              v-model="eventData.onsite"
              autocomplete="off"
            ></textarea>
          </div>
          <div class="input-block mb-x2">
            <label for="meals">
              meals
            </label>
            <textarea
              id="meals"
              name="meals"
              placeholder=""
              class="standard-text-area"
              v-model="eventData.meals"
              autocomplete="off"
            ></textarea>
          </div>
          <div class="input-block mb-x2">
            <label for="details">
              additional details
            </label>
            <textarea
              id="details"
              name="details"
              placeholder=""
              class="standard-text-area"
              v-model="eventData.details"
              autocomplete="off"
            ></textarea>
          </div>
          <div class="input-block mb-x2">
            <label for="guidelines">
              EC Photog guidelines
            </label>
            <textarea
              id="guidelines"
              name="guidelines"
              placeholder=""
              class="standard-text-area"
              v-model="eventData.guidelines"
              autocomplete="off"
            ></textarea>
          </div>
          <div class="input-block mb-x2">
            <label for="agenda">
              EC program agenda
            </label>
            <textarea
              id="agenda"
              name="agenda"
              placeholder=""
              class="standard-text-area"
              v-model="eventData.agenda"
              autocomplete="off"
            ></textarea>
          </div>
          <div class="input-block mb-x2">
            <label for="delivery">
              image delivery
            </label>
            <textarea
              id="delivery"
              name="delivery"
              placeholder=""
              class="standard-text-area"
              v-model="eventData.delivery_instructions"
              autocomplete="off"
            ></textarea>
          </div>
          <!-- hardcoded "read the job sheet" at the moment" -->
          <!-- <div class="input-block mb-x2">
            <label for="reimbursable">
              reimbursable items
            </label>
            <textarea
              id="reimbursable"
              name="reimbursable"
              placeholder=""
              class="standard-text-area"
              v-model="eventData.reimbursable"
              autocomplete="off"
            ></textarea>
          </div>
          <div class="input-block mb-x2">
            <label for="invoice">
              invoice instructions
            </label>
            <textarea
              id="invoice"
              name="invoice"
              placeholder=""
              class="standard-text-area"
              v-model="eventData.invoice"
              autocomplete="off"
            ></textarea>
          </div> -->
          <div class="zero-btn zero-btn-standard zero-btn-primary" @click="postEvent()" v-if="!editMode">
            Create Job
          </div>
          <div class="zero-btn zero-btn-standard zero-btn-primary" @click="putEvent()" v-if="editMode">
            Update Job
          </div>
        </div>
      </div>
    </div>
    <!-- modal town -->
    <div class="modal-container" :class="{ 'show-modal' : verifyDelete }">
      <div class="modal-card">
        <h4>Delete this job?</h4>
        <p class="mb-x4">This action cannot be undone.</p>
        <button class="zero-btn zero-btn-standard zero-btn-destructive zero-btn-outline width-100 mb-x2" @click="deleteEvent()">
          <i class="fas fa-trash mr-x1"></i>Delete this job
        </button>
        <button class="zero-btn zero-btn-standard zero-btn-tertiary zero-btn-outline width-100" @click="verifyDelete = false">
          Cancel
        </button>
      </div>
    </div>
    <!-- new event complete -->
    <div class="modal-container" :class="{ 'show-modal' : addDaysModalId }">
      <div class="modal-card">
        <h4>Job Created!</h4>
        <p class="mb-x4">Would you like to enter days for this job?</p>
        <router-link :to="'/jobs/' + addDaysModalId + '/days'" class="zero-btn zero-btn-standard zero-btn-primary mb-x2 width-100">
          <i class="fas fa-calendar mr-x1"></i>Add days for this job
        </router-link>
        <router-link :to="'/jobs/all'" class="zero-btn zero-btn-standard zero-btn-tertiary width-100">
          Maybe later
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import VueCookies from 'vue-cookies'
import Nav from '@/components/Nav.vue'
import CreativesList from '@/components/CreativesList.vue'
import PageLoader from '@/components/PageLoader.vue'

Vue.use(VueCookies)
// import shared from '@/shared.js'
// example usage: shared.parseDate('2012-08-11')
const axios = require('axios')

// endpoints
const apiChoice = process.env.VUE_APP_API_URL

// Using route params
// $route.params.id
// from path: '/user/:id',

export default {
  name: 'home',
  components: {
    Nav,
    CreativesList,
    PageLoader
  },
  data () {
    return {
      isLoading: false,
      userToken: '',
      isLoggedIn: false,
      userData: {
        'id': '',
        'name': '',
        'email': ''
      },
      eventId: '',
      eventData: {
        'event_name': '',
        'location': '',
        'floorplan_path': '',
        'calltime': '',
        'agenda': '',
        'onsite': '',
        'guidelines': '',
        'invoice': '',
        'travel': '',
        'creatives': '',
        'services': '',
        'meals': '',
        'details': '',
        'delivery_instructions': '',
        'reimbursable': '',
        'headshotcafe': '',
        'video': '',
        'traveldates': '',
        'flighthotel': '',
        'assignments': ''
      },
      errors: {
        'name': false,
        'start': false,
        'end': false,
        'location': false
      },
      editMode: false,
      verifyDelete: false,
      users: [],
      addDaysModalId: '',
      assignmentFile: '',
      flightHotelFile: '',
      filePath: apiChoice
    }
  },
  created () {
    this.isLoading = true
    if (this.$cookies.isKey('u')) {
      this.isLoggedIn = true
      this.userData = this.$cookies.get('u')
      this.userToken = this.$cookies.get('j') + '.' + this.$cookies.get('w') + '.' + this.$cookies.get('t')
    }
    if (this.$route.params.eventid) {
      this.eventId = this.$route.params.eventid
      this.editMode = true
      this.getEvent()
    } else {
      this.getUsers()
    }
  },
  methods: {
    getEvent () {
      axios
        .get(apiChoice + 'api/events/' + this.eventId, {
          headers: {
            'Cache-Control': 'no-cache',
            'Authorization': 'Bearer ' + this.userToken
          }
        })
        .then((response) => {
          this.eventData = response.data
          this.getUsers()
          // stop loading
          // this.isLoading = false
        })
        .catch((error) => {
          console.log('error occurred')
          console.log(error)
          this.output = error.response.data
          // this.isLoading = false
        })
    },
    postEvent () {
      this.isLoading = true
      // create form data
      let formData = new FormData()
      // check for selected files
      if (document.getElementById('assignment-input').value !== '') {
        formData.append('assignments', document.getElementById('assignment-input').files[0])
      } else {
        formData.append('assignments', null)
      }
      if (document.getElementById('flighthotel-input').value !== '') {
        formData.append('flighthotel', document.getElementById('flighthotel-input').files[0])
      } else {
        formData.append('flighthotel', null)
      }
      // load up form data form json
      formData.append('event_name', this.eventData.event_name)
      formData.append('location', this.eventData.location)
      formData.append('floorplan_path', this.eventData.floorplan_path)
      formData.append('calltime', this.eventData.calltime)
      formData.append('agenda', this.eventData.agenda)
      formData.append('onsite', this.eventData.onsite)
      formData.append('guidelines', this.eventData.guidelines)
      formData.append('invoice', this.eventData.invoice)
      formData.append('travel', this.eventData.travel)
      formData.append('creatives', this.eventData.creatives)
      formData.append('services', this.eventData.services)
      formData.append('meals', this.eventData.meals)
      formData.append('details', this.eventData.details)
      formData.append('delivery_instructions', this.eventData.delivery_instructions)
      formData.append('reimbursable', this.eventData.reimbursable)
      formData.append('headshotcafe', this.eventData.headshotcafe)
      formData.append('video', this.eventData.video)
      formData.append('traveldates', this.eventData.traveldates)
      axios
        .post(apiChoice + 'api/events', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': 'Bearer ' + this.userToken
          }
        })
        .then((response) => {
          // do something with response.data.data
          // check what response is and route to details for job or days for job using
          // the response job id
          this.addDaysModalId = response.data.id
          // stop loading
          // this.isLoading = false
        })
        .catch((error) => {
          console.log('error occurred')
          console.log(error)
          this.output = error.response.data
          // this.isLoading = false
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    putEvent () {
      this.isLoading = true
      // create form data
      let formData = new FormData()
      // check for selected files
      if (document.getElementById('assignment-input').value !== '') {
        formData.append('assignments', document.getElementById('assignment-input').files[0])
      }
      if (document.getElementById('flighthotel-input').value !== '') {
        formData.append('flighthotel', document.getElementById('flighthotel-input').files[0])
      }
      // load up form data form json
      formData.append('event_name', this.eventData.event_name)
      formData.append('location', this.eventData.location)
      formData.append('floorplan_path', this.eventData.floorplan_path)
      formData.append('calltime', this.eventData.calltime)
      formData.append('agenda', this.eventData.agenda)
      formData.append('onsite', this.eventData.onsite)
      formData.append('guidelines', this.eventData.guidelines)
      formData.append('invoice', this.eventData.invoice)
      formData.append('travel', this.eventData.travel)
      formData.append('creatives', this.eventData.creatives)
      formData.append('services', this.eventData.services)
      formData.append('meals', this.eventData.meals)
      formData.append('details', this.eventData.details)
      formData.append('delivery_instructions', this.eventData.delivery_instructions)
      formData.append('reimbursable', this.eventData.reimbursable)
      formData.append('headshotcafe', this.eventData.headshotcafe)
      formData.append('video', this.eventData.video)
      formData.append('traveldates', this.eventData.traveldates)
      // adding this to make it a put
      formData.append('_method', 'PUT')
      // set as post to get around formdata + put not working together
      axios
        .post(apiChoice + 'api/events/' + this.eventId, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': 'Bearer ' + this.userToken
          }
        })
        .then((response) => {
          // do something with response.data.data
          this.$router.push({ path: '/jobs/' + this.eventId })
          // stop loading
          // this.isLoading = false
        })
        .catch((error) => {
          console.log('error occurred')
          console.log(error)
          this.output = error.response.data
          // this.isLoading = false
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    deleteEvent () {
      this.isLoading = true
      axios
        .delete(apiChoice + 'api/events/' + this.eventId, {
          headers: {
            'Cache-Control': 'no-cache',
            'Authorization': 'Bearer ' + this.userToken
          }
        })
        .then((response) => {
          this.$router.push({ path: '/jobs/all' })
          // stop loading
          // this.isLoading = false
        })
        .catch((error) => {
          console.log('error occurred')
          console.log(error)
          this.output = error.response.data
          // this.isLoading = false
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    getUsers () {
      this.isLoading = true
      axios
        .get(apiChoice + 'api/users', {
          headers: {
            'Cache-Control': 'no-cache',
            'Authorization': 'Bearer ' + this.userToken
          }
        })
        .then((response) => {
          // transfer the response
          this.users = response.data
        })
        .catch((error) => {
          console.log(error.response.data)
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    goBack () {
      // if profile => back to profile
      // if user create => back to users
      // if user edit => back to users dets
      if (this.editMode) {
        this.$router.push({ path: '/jobs/' + this.eventId })
      } else {
        this.$router.push({ path: '/jobs' })
      }
    },
    setCreatives (selectedCreatives) {
      this.eventData.creatives = selectedCreatives
    },
    fileInputChange (ref) {
      switch (ref) {
        case 'assignmentinput':
          this.assignmentFile = this.$refs.assignmentinput.files
          break
        case 'flighthotelinput':
          this.flightHotelFile = this.$refs.flighthotelinput.files
          break
      }
    }
  }
}
</script>

<style scoped lang="scss">
.tab-content .menu-info{
  h2{
    display: block;
  }
}
.uploaded-image{
  max-width: 200px;
}

// Media Queries
// Small devices (landscape phones, 576px and up)
@media (min-width: 576px) {
}
// Medium devices (tablets, 768px and up)
@media (min-width: 768px) {
}
// Large devices (desktops, 992px and up)
@media (min-width: 992px) {
}
// Extra large devices (large desktops, 1200px and up)
@media (min-width: 1200px) {
}
</style>
